import dynamic from 'next/dynamic';

const HeaderNew = dynamic(() => import(/* webpackChunkName: "boatWebHeaderNew" */ './Header'));

const HeaderOld = dynamic(() => import(/* webpackChunkName: "boatWebHeader" */ './HeaderOld'));

// temp flag to allow testing new header on stage
const Header = process.env.BI_USE_NEW_HEADER ? HeaderNew : HeaderOld;

export default Header;
